export default {
  /** интервал проверки на обновление в секундах */
  checkInterval: 60
};